module.exports = __webpack_public_path__ + "static/media/windshield-protection.fae34cd8.png";